//
// Spin Controller
//
// ----------------------------
spinController = {};
spinController.mainSpinConfig = {};
spinController.nudgeSpinConfig = {};

spinController.mainLandConfig = {};
spinController.nudgeLandConfig = {};

spinController.mainLandOffsets = [0, 0, 0, 0, 0];
spinController.nudgeLandOffsets = [0, 0, 0, 0, 0];

spinController.mainSpinTimeOffsets = [0, 0, 0, 0, 0];
spinController.nudgeSpinTimeOffsets = [0, 0, 0, 0, 0];

spinController.startSpin = function () {
  spinController.mainSpinConfig = {};
  spinController.nudgeSpinConfig = {};

  spinController.mainLandConfig = {};
  spinController.nudgeLandConfig = {};

  gameController.mainReelAnticipationSoundStarted = false;
  gameController.nudgeReelAnticipationSoundStarted = false;

  for (let i = 0; i < 5; i++) {
    let mainReelStartOffset = 0.05 * i;
    let mainReelSpinOffset = 0.05 * i;

    let mainReel = {
      type: 'main',
      startDelay: 0.4,
      reelStartDelayOffset: mainReelStartOffset,
      pullbackAmount: 0.3,
      pullbackTime: 0.1,
      pullbackStrength: 3.0,
      accelerationTime: 0.5,
      accelerationStrength: 2.0,
      symbolsPerSecond: 20,
      mainReelSpinTime: 0.3,
      mainReelSpinTimeReelOffset: mainReelSpinOffset,
      decelerationTime: 0.1,
      decelerationStrength: 3.0,
      bounceAmount: 0,
      bounceTime: 0,
    };
    let mainReelSpinOffsets = mainReelStartOffset + mainReelSpinOffset;

    spinController.mainSpinTimeOffsets[i] = mainReelSpinOffsets;
    spinController.mainSpinConfig[`reel${i}`] = mainReel;

    let nudgeReelStartOffset = 0.1 * i;
    let nudgeReelSpinOffset = 0.1 * i;

    let nudgeReel = {
      type: 'nudge',
      startDelay: 0,
      reelStartDelayOffset: nudgeReelStartOffset,
      pullbackAmount: 0.5,
      pullbackTime: 0.2,
      pullbackStrength: 4.0,
      accelerationTime: 0.5,
      accelerationStrength: 2.0,
      symbolsPerSecond: 30,
      mainReelSpinTime: 0.5,
      mainReelSpinTimeReelOffset: nudgeReelSpinOffset,
      decelerationTime: 0.5,
      decelerationStrength: 3.0,
      bounceAmount: 0,
      bounceTime: 0,
    };
    let nudgeReelSpinOffsets = nudgeReelStartOffset + nudgeReelSpinOffset;

    spinController.nudgeLandOffsets[i] = nudgeReelSpinOffsets;
    spinController.nudgeSpinConfig[`reel${i}`] = nudgeReel;
  }

  gameController.slotMachine.dynamicSpin(spinController.mainSpinConfig);
  gameController.nudgeSlotMachine.dynamicSpin(spinController.nudgeSpinConfig);
};

spinController.stopSpin = function (
  symbols,
  above,
  below,
  mainSpinCompleteCallback,
  nudgeSymbols,
  nudgeSymbolsAbove,
  nudgeSymbolsBelow,
  nudgeSpinCompleteCallback,
  serverData
) {
  // For this game anticipation will happen on all reels after two bonus symbols
  // starting with all 5 main reels followed by all 5 nudge reels

  spinController.longSpinMainReels = [false, false, false, false, false];
  spinController.longSpinNudgeReels = [false, false, false, false, false];

  spinController.checkForLongSpinReels(symbols, nudgeSymbols);
  spinController.setupLandConfigs();

  gameController.slotMachine.stopReels(symbols, above, below, mainSpinCompleteCallback, spinController.mainLandConfig);
  gameController.nudgeSlotMachine.stopReels(
    nudgeSymbols,
    nudgeSymbolsAbove,
    nudgeSymbolsBelow,
    nudgeSpinCompleteCallback,
    spinController.nudgeLandConfig,
    serverData
  );
};

spinController.setupLandConfigs = function () {
  let desiredMainReelAnticipationTime = 5.5;
  let numOfMainReelsAnticipating = 0;

  for (let i = 0; i < spinController.longSpinMainReels.length; i++) {
    if (spinController.longSpinMainReels[i]) {
      numOfMainReelsAnticipating++;
    }
  }

  for (let i = 0; i < spinController.longSpinMainReels.length; i++) {
    let mainReel = {};
    let decelTime = 0.3;
    let mainSpinExtension = 0;
    let reelTime = 0;
    let reelOffset = spinController.mainSpinTimeOffsets[i];

    if (spinController.longSpinMainReels[i]) {
      if (i === 4) {
        reelTime = desiredMainReelAnticipationTime - reelOffset;
      } else if (i === 3) {
        reelTime = desiredMainReelAnticipationTime - reelOffset;
        if (numOfMainReelsAnticipating === 2) {
          reelTime /= 2;
        } else {
          reelTime /= 3;
          reelTime *= 2;
        }
      } else if (i === 2) {
        reelTime = desiredMainReelAnticipationTime - reelOffset;
        reelTime = reelTime / 3;
      }
      decelTime = reelTime / 2;
      mainSpinExtension = reelTime - decelTime;
    }

    mainReel = {
      type: 'main',
      mainReelSpinExtension: mainSpinExtension,
      decelerationTime: decelTime,
      decelerationStrength: 3.0,
      bounceAmount: 0,
      bounceTime: 0,
    };
    spinController.mainLandConfig[`reel${i}`] = mainReel;
  }

  let desiredNudgeReelAnticipationTime = 3.0;
  let numOfNudgeReelsAnticipating = 0;

  for (let i = 0; i < spinController.longSpinNudgeReels.length; i++) {
    if (spinController.longSpinNudgeReels[i]) {
      numOfNudgeReelsAnticipating++;
    }
  }

  let nudgeAnticipationCount = 0;
  for (let i = 0; i < spinController.longSpinNudgeReels.length; i++) {
    let nudgeReel = {};
    let decelTime = 0.5;
    let mainSpinExtension = 0;
    let reelTime = 0;
    let reelOffset = spinController.nudgeSpinTimeOffsets[i];

    if (spinController.longSpinNudgeReels[i]) {
      nudgeAnticipationCount++;
      if (i === 4) {
        reelTime = desiredNudgeReelAnticipationTime - reelOffset;
      } else {
        let reelSegment = desiredNudgeReelAnticipationTime / numOfNudgeReelsAnticipating;
        reelSegment *= nudgeAnticipationCount;
        reelTime = reelSegment - reelOffset;
      }
      decelTime = reelTime / 2;
      mainSpinExtension = reelTime - decelTime;

      if (numOfMainReelsAnticipating > 0) {
        mainSpinExtension += desiredMainReelAnticipationTime;
      }
    }

    nudgeReel = {
      type: 'nudge',
      mainReelSpinExtension: mainSpinExtension + 0.5,
      decelerationTime: decelTime,
      decelerationStrength: 3.0,
      bounceAmount: 0,
      bounceTime: 0,
    };

    // Nudge specific
    nudgeReel.landOffset = spinController.nudgeLandOffsets[i]; // landOffset in pixels
    nudgeReel.nudgeThisSpin = gameController.isTopHitReelNudged;
    spinController.nudgeLandConfig[`reel${i}`] = nudgeReel;
  }
};

spinController.checkForLongSpinReels = function (symbols, nudgeSymbols) {
  let bonusCount = 0;

  // Main reels
  for (let reel = 0; reel < 5; reel++) {
    for (let row = 0; row < 3; row++) {
      if (bonusCount >= 2) {
        spinController.longSpinMainReels[reel] = true;
      }
      if (symbols[reel][row] === 15) {
        bonusCount++;
        break;
      }
    }
  }

  // Nudge reels
  for (let i = 0; i < gameController.fullSymbolsOnTopHitReel.length; i++) {
    if (bonusCount >= 2) {
      spinController.longSpinNudgeReels[i] = true;
    }
    if (gameController.fullSymbolsOnTopHitReel[i] === 15) {
      bonusCount++;
    }
  }
};
